export const BASE_URL = import.meta.env.VITE_API_BASE_URL

const URL = {
  Auth: {
    Register: 'auth/register',
    Login: 'auth/login/email',
    RequestLoginOtp: 'auth/request-login-otp',
    VerifyLoginOtpLogin: 'auth/verify-login-otp',
    VerifyOtp: 'auth/verify-otp',
    ResendOtp: 'auth/resend-otp',
    ForgotPassword: 'auth/forgot-password',
    ResetPassword: 'auth/reset-password',
    Logout: 'auth/logout',
    ConnectToDrive: 'auth/connect/drive',
    LoginInit: 'auth/login/init',
    VerifyLoginOtp: 'auth/login/verify-otp',
    LoginWithPassword: 'auth/login/password',
    LoginWithEmail: 'auth/login/',
    LinkIdentifier: 'auth/link',
    VerifyLinkOtp: 'auth/verify-linkOtp',
    LinkPassword: 'auth/link/password',
    VerifyLinkPassword: 'auth/verify/link-password',
  },
  Chat: {
    GetContacts: 'chat/get-contacts',
    SearchContacts: 'chat/search/contact',
    GetBlock: 'chat/get-block',
    Unblock: 'chat/toggle-block',
    GetFavorite: 'chat/get-favorite',
    SearchFavorite: 'chat/search-favorite',
    ToggleFavorite: 'chat/toggle-favorite',
    GetRecentChats: 'chat/recent-chats',
    GetSearchRecent: 'chat/search/recent-chats',
    ToggleBlock: 'chat/toggle-block',
    TogglePinChat: 'chat/pin',
    ArchiveChat: 'chat/toggle-archive',
    UnarchiveChat: 'chat/toggle-archive',
    SearchBlock: 'chat/search-block',
    Archive: 'chat/get-archive',
    SearchArchive: 'chat/search-archive',
    Unarchive: 'chat/toggle-archive',
    Export: 'chat/export',
    Clear: 'chat/clear',
    ArchiveAll: 'chat/archive/all',
    ClearAll: 'chat/clear/all',
    DeleteAll: 'chat/delete/all',
    Delete: 'chat/delete',
    MuteChat: 'chat/mute',
    UnmuteChat: 'chat/unmute',
    GetContactsDetails: 'chat/contact-info',
  },
  Group: {
    List: 'group/all',
    UserGroups: 'group/my-group',
    Info: 'group/get/:id',
    Create: 'group/create',
    Update: 'group/update',
    Delete: 'group/delete',
    Leave: 'group/leave',
    Members: 'group/members',
    AddMember: 'group/member/add',
    RemoveMember: 'group/member/remove',
    UpdateMemberRole: 'group/member/update/role',
    UpdateSettings: 'group/setting/update',
  },
  Broadcast: {
    Create: 'broadcast/create',
    MyBroadcasts: 'broadcast/my-broadcasts',
    Details: 'broadcast/:broadcast_id',
    Update: 'broadcast/:broadcast_id',
    Delete: 'broadcast/:broadcast_id',
    AddRecipients: 'broadcast/:broadcast_id/recipients',
    RemoveRecipients: 'broadcast/:broadcast_id/recipients',
  },
  Profile: {
    UpdateDetails: 'account/updateProfile',
    Details: 'account/getUserDetails',
    UpdatePassword: 'account/updatePassword',
    UserProfile: 'account/:id/profile',
    Delete: 'account/delete',
  },
  Notifications: {
    List: 'notification',
    Delete: 'notification/delete',
    UnreadCount: 'notification/unread-count',
    MarkAllAsRead: 'notification/mark-all-read',
  },
  Friends: {
    PendingRequests: 'friend/pending-request',
    Suggestions: 'friend/suggestions',
    SendRequest: 'friend/send-request',
    Respond: 'friend/respond',
    AcceptedFriends: 'friend/accepted',
    SearchFriends: 'friend/search-friend',
  },
  Messages: {
    GetMessages: 'message/get',
    SendMessage: 'message/send',
    UploadDocuments: 'message/documents',
    UploadImages: 'message/images',
    UploadVideos: 'message/videos',
    GetDocuments: 'message/get-documents',
    SearchDocument: 'message/search-document',
    EditMessage: 'message/edit',
    DeleteMessage: 'message/delete',
    StarMessage: 'message/star',
    PinMessage: 'message/pin',
    ForwardMessage: 'message/forward',
    SearchMessages: 'message/search',
    MessageReaction: 'message/toggle-reaction',
    DisappearingMessages: 'message/toggle-disappear',
    MarkAsRead: 'message/mark/read',
  },
  Call: {
    Initiate: 'call/initiate',
    Answer: 'call/answer',
    Decline: 'call/decline',
    End: 'call/end',
    History: 'call/history',
  },
  Status: {
    Feed: 'status',
    Create: 'status/create',
    View: 'status/view',
    Delete: 'status/delete',
    Mute: 'status/mute',
    GetMutedStatuses: 'status/fetch/mute',
    Reply: 'status/reply',
  },
  ChatWallpaper: {
    GetAll: 'wallpaper/all',
  },
  Sticker: {
    GetAll: 'sticker/all',
  },
  FAQ: {
    GetAllFaqs: 'faq/all',
  },
  Page: {
    GetAllPages: 'page',
  },
  Settings: {
    GetSettings: 'setting',
    GetPublicSettings: 'setting/public',
    UpdateSettings: 'setting/update',
  },
  ReportSettings: {
    GetAllReportSettings: 'report/all',
  },
  ReportedAccounts: {
    GetCreateReportedAccounts: 'user-report/create',
  },
  UserSetting: {
    GetSetting: 'user-setting/:id',
    UpdateUserSetting: 'user-setting/update',
    ForgetChatLockPin: 'user-setting/forgot/pin',
    VerifyChatLockPinOtp: 'user-setting/verify/pin',
    ResetChatLockPin: 'user-setting/reset/chat-pin',
  },
  Contact: {
    Create: 'inquiry/create',
  },
  E2E: {
    SavePublicKey: 'e2e/keys',
    GetPublicKey: 'e2e/keys/:user_id',
    DeletePublicKey: 'e2e/delete/keys',
  },
  Plan: {
    GetAllPlans: 'plan',
    GetActivePlans: 'plan/active',
    GetPlanById: 'plan/:id',
  },
  Subscription: {
    GetMySubscription: 'subscription/my',
    GetUserLimits: 'subscription/limits',
    GetSubscriptionDetails: 'subscription/:id',
  },
  Verification: {
    InitiateVerification: 'verification/initiate',
    ConfirmPayment: 'verification/confirm',
    SyncStripeSubscription: 'verification/sync-stripe',
    GetMyStatus: 'verification/my-status',
    UploadDocuments: 'verification/upload/doc',
  },
  Language: {
    GetTranslation: 'language/:locale/translation',
  },
  Impersonation: {
    Status: 'impersonate/status',
    Stop: 'impersonate/stop',
  },
} as const

export const URL_KEYS: {
  [K in keyof typeof URL]: { [P in keyof (typeof URL)[K]]: string }
} = Object.fromEntries(
  Object.entries(URL).map(([key, subKeys]) => [
    key,
    Object.fromEntries(Object.entries(subKeys).map(([subKey, path]) => [subKey, `${BASE_URL}${path}`])),
  ]),
) as {
  [K in keyof typeof URL]: { [P in keyof (typeof URL)[K]]: string }
}
